import script from "./AddAccountMotionBank.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAccountMotionBank.vue?vue&type=script&setup=true&lang=js"

import "./AddAccountMotionBank.vue?vue&type=style&index=0&id=5125fa60&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5125fa60"]])

export default __exports__